"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPinOrderGenerator = exports.getGroupNumberFromOrder = exports.getGroupFromOrder = exports.orderableCompareFn = exports.defaultGroupOrder = exports.defaultGroup = exports.defaultOrder = void 0;
const fractional_indexing_jittered_1 = require("fractional-indexing-jittered");
exports.defaultOrder = 'a0';
exports.defaultGroup = 'g00'; // 2 digits to eventually support more than 10 phases
exports.defaultGroupOrder = `${exports.defaultGroup}${exports.defaultOrder}`;
const generatedIndexGroupIdLength = 3;
function orderableCompareFn(a, b) {
    if (a.order < b.order)
        return -1;
    if (a.order > b.order)
        return 1;
    if (a.id < b.id)
        return -1;
    if (a.id > b.id)
        return 1;
    return 0;
}
exports.orderableCompareFn = orderableCompareFn;
function getGroupFromOrder(order) {
    return order.substring(0, generatedIndexGroupIdLength);
}
exports.getGroupFromOrder = getGroupFromOrder;
function getGroupNumberFromOrder(order) {
    return parseInt(order.substring(1, generatedIndexGroupIdLength), 10);
}
exports.getGroupNumberFromOrder = getGroupNumberFromOrder;
function getPinOrderGenerator(orders) {
    // TODO: do we need to sort the orders always, should improve
    const sorted = [...orders].sort();
    return new fractional_indexing_jittered_1.IndexGenerator(sorted, { groupIdLength: generatedIndexGroupIdLength, useJitter: true });
}
exports.getPinOrderGenerator = getPinOrderGenerator;
//# sourceMappingURL=order.js.map